<div class="close-container">
  <mat-icon class="close-icon" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="title title--lg dialog" mat-dialog-title>Search Results</div>
<div class="smallerText mat-radio-label-content">Location Information will not be published. It is used to assist in
  appropriate selection.</div>
  <div class="smallerText required-text mat-radio-label-content" *ngFor="let error of results.errors">
    {{error}}
  </div>
<mat-dialog-content>
  <mat-radio-group aria-label="Select an option" class="radio" [(ngModel)]="facultyMember">
    <mat-radio-button [value]="newFacultyMember">
      <div class="list-font">Add New Faculty</div>
      <div class="smallerText list-font">None of the contacts below match. Please add a new one</div>
    </mat-radio-button>
    <mat-radio-button *ngFor="let item of results.contacts" [value]="item" [disabled]="!item.isEligibleToAdd">
      <div class="list-font">{{item.firstName}} {{item.lastName}}</div>
      <div class="smallerText list-font">{{item.cityStateFormatted}}</div>
      <div class="smallerText required-text" *ngIf="!item.isEligibleToAdd">
        Contact is associated to a different institution.<br>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="btn--inline dialog-btn-container">
    <button (click)="dialogRef.close()" class="btn btn--small btn--outline">Faculty Not Found</button>
    <button (click)="addFaculty()" class="btn btn--small btn--solid btn--red">Add Faculty</button>
  </div>
</mat-dialog-actions>
